import React from 'react'

export default class LineChart extends React.Component {
  onTouchEnd = (e) => {
    this.props.setHoverColumn(null)
  }

  onHoverByTouch = (e) => {
    const touch = e.targetTouches.item(0)
    const el = touch.target.closest('.line-chart')
    const options = el.querySelectorAll('[data-idx]')

    let idx = null
    for (const o of options) {
      const b = o.getBoundingClientRect()
      if (touch.clientX < b.x + b.width) {
        idx = Number(o.dataset.idx)
        break
      }
    }
    this.props.setHoverColumn(idx)
  }

  render() {
    const { data, title, goal, hoverColumn, hoverDayString } = this.props
    const max = data.reduce((running, d) => Math.max(running, d), goal * 1.1) + 1

    return (
      <div
        className="line-chart"
        onTouchStart={this.onTouchStart}
        onTouchMove={this.onHoverByTouch}
        onTouchEnd={this.onTouchEnd}
      >
        <div className="title">{title}</div>
        <div className="subtitle">Click or swipe over the chart to see step counts.</div>
        {hoverColumn !== null && (
          <div className="hover-info">
            {hoverDayString}
            <div style={{ flex: 1 }} />
            {Number(data[hoverColumn]).toLocaleString()} steps
          </div>
        )}
        <div className="columns">
          {data.length === 0 || !data.find((v) => v !== 0) ? (
            <div className="empty">No data to display.</div>
          ) : (
            data.map((v, idx) => (
              <div
                key={idx}
                data-idx={idx}
                onClick={() => this.props.setHoverColumn(idx)}
                onMouseEnter={() => this.props.setHoverColumn(idx)}
                onMouseLeave={() => this.props.setHoverColumn(null)}
                className={`column ${v > goal && 'past-goal'} ${hoverColumn === idx && 'active'}`}
              >
                <div style={{ height: `${(100 * v) / max}%` }} className="fill" />
              </div>
            ))
          )}
          <div className="goal" style={{ top: `${100 - (100 * goal) / max}%` }} />
        </div>
      </div>
    )
  }
}
